import { getRoute } from "@utils/route";

export const PERSONAL_ACCIDENT_INSURANCE_PAGE_URL = '/personal-accident-insurance';

export const routePersonalAccidentInsurancePage = () => getRoute(PERSONAL_ACCIDENT_INSURANCE_PAGE_URL);
